import type { FaireOrderEntity } from "../../entity_types/order";

export const _6MV94Q99MD: FaireOrderEntity = {
  token: "6MV94Q99MD",
  type: "order",
  orderNumber: "#6MV94Q99MD",
  status: "new",
  totalDollars: 196.55,
  customerName: "amber marie and company",
  firstOrder: true,
  placedAt: "Nov 28, 2025",
  sourceLabel: "Marketplace",
  commissionNote: "First order",
  payoutDate: "Pending Ship",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "entity-db-bootstrap",
  },
};
